import {
  CheckIcon,
  GKButton,
  GKEditor,
  GKModal,
  GKTextField,
  Grid2,
  InfoItalicIcon,
  Typography,
} from "components";
import { Controller, useForm } from "react-hook-form";
import {
  useCreateFaqEntryMutation,
  useUpdateFaqEntryMutation,
} from "store/features/MyWebsite";
import { GKModalProps } from "utils/commonInterface";
import { Faq } from "./types";

const FaqModal = (props: GKModalProps & { selectedRowData: Faq | null }) => {
  const { open, setOpen, selectedRowData } = props;

  const [createFaqEntry, { isLoading }] = useCreateFaqEntryMutation();
  const [updateFaqEntry, { isLoading: updateFaqEntryLoading }] =
    useUpdateFaqEntryMutation();

  const form = useForm({
    defaultValues: {
      question: selectedRowData?.rowId ? selectedRowData?.question : "",
      answer: selectedRowData?.rowId ? selectedRowData?.answer : "",
    },
  });

  return (
    <GKModal
      setOpen={setOpen}
      open={open}
      width={"550px"}
      maxHeight="calc(100vh - 300px)"
      modalTitle={selectedRowData?.rowId ? "Update FAQ" : "Add New FAQ"}
      footer={
        <GKButton
          variant="contained"
          startIcon={<CheckIcon />}
          // type="submit"
          // form="faq-modal"
          loading={isLoading || updateFaqEntryLoading}
          onClick={form.handleSubmit(async (data) => {
            try {
              if (selectedRowData?.rowId) {
                await updateFaqEntry({
                  id: selectedRowData.rowId,
                  body: data,
                }).unwrap();
              } else {
                await createFaqEntry(data).unwrap();
              }
              setOpen(false);
            } catch (err) {
              console.error("Create faq entry failed:", err);
            }
          })}
        >
          {selectedRowData?.rowId ? "Save Changes" : "Add FAQ"}
        </GKButton>
      }
    >
      <Grid2 container spacing={2}>
        <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
          <InfoItalicIcon color="var(--neutral-500)" />
          <Typography fontSize={12} color="var(--neutral-500)">
            {selectedRowData?.rowId
              ? "Update the question or answer below. Changes will reflect immediately on your website after saving."
              : "Write like you're answering a client directly. Keep it short, clear, & helpful."}
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Controller
            control={form.control}
            rules={{
              required: { value: true, message: "Please enter question" },
            }}
            name={"question"}
            render={({ field, fieldState: { error } }) => {
              return (
                <GKTextField
                  {...field}
                  inputLabel="Question"
                  error={!!error}
                  helperText={error?.message}
                />
              );
            }}
          />
        </Grid2>
        <Grid2 size={12}>
          <Controller
            control={form.control}
            name={"answer"}
            rules={{
              required: { value: true, message: "Please enter answer" },
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <GKEditor
                  {...field}
                  inputLabel="answer"
                  requiredField
                  error={!!error}
                  helperText={error?.message}
                  toolbar={[
                    "undo",
                    "redo",
                    "|",
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "|",
                    "link",
                    "|",
                    "bulletedList",
                    "numberedList",
                  ]}
                />
              );
            }}
          />
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default FaqModal;
